<template>
  <div class="query_box">
    <iframe id="queryIframe"
            :src="iframeSrc"
            frameborder="0"></iframe>
  </div>
</template>

<script>
import { getSessionStorage, setSessionStorage, getToken } from '@/utils/stage'
export default {
  data() {
    return {
      title: '',
      iframeSrc: '',
    }
  },
  created() {
    this.init()
  },
  watch: {
    title(newVal) {
      console.log('newVal', newVal)
    },
  },
  methods: {
    init() {
      const accountStorage = JSON.parse(getSessionStorage('accountStorage'))
      const srcUrl = accountStorage.web_config.service_url
      const zm = accountStorage.web_config.zm
      // const srcUrl = 'http://localhost:3002'
      this.iframeSrc = `${srcUrl}/#/queryCenter?clientAppId=${
        accountStorage.app_id
      }&accesstoken=${accountStorage.access_token}&uid=${
        accountStorage.uid
      }&user=${accountStorage.role_name}&serve=${accountStorage.serve}&lang=${
        accountStorage.lang
      }&zm=${zm}&time=${new Date().getTime()}`
      console.log(this.iframeSrc)
      const that = this
      window.addEventListener('message', function (e) {
        let data = e && e.data //父页面接收到的子页面传递过来的数据
        if (data.data) {
          this.title = data.data.title
          that.callback(this.title)
        }
      })
    },
    callback(data) {
      const webtitle = document.getElementById('webTitle')
      webtitle.innerHTML = data
    },
  },
}
</script>

<style lang="less" scoped>
.query_box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  #queryIframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
